import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h5",
    { staticClass: "subtitle-1" },
    [
      _vm._v(_vm._s(_vm.title) + ": "),
      _vm.help !== ""
        ? _c(
            VTooltip,
            {
              attrs: { top: "", attach: true },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var attrs = ref.attrs
                      var on = ref.on
                      return [
                        _c(
                          VIcon,
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "pointer pr-1",
                                attrs: { small: "" },
                              },
                              "v-icon",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._v("mdi-information-outline")]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3715297551
              ),
            },
            [_c("span", [_vm._v(_vm._s(_vm.help))])]
          )
        : _vm._e(),
      _vm._v(
        " " +
          _vm._s(
            _vm._f("formatCurrency")(_vm.value, {
              decimalDigits: 0,
              decimalSeparator: ".",
              thousandsSeparator: ",",
              currencySymbolNumberOfSpaces: 0,
              currencySymbolPosition: "left",
            })
          )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }